export default __webpack_public_path__ + "static/media/box-background-color-hh1.834c520e.png";